import React, { useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import {
    BiCartAlt,
    BiUserCircle, 
    BiX
} from 'react-icons/bi';
import Hamburger from 'components/Navbar/Hamburger';
import ButtonLink from 'components/ButtonLink';
import PrepSharpLogo from 'assets/svg/logo.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { closeMessage } from 'store/cart';
import './index.css';

function Navbar({ transparent }: { transparent: boolean; }) {
    const { user } = useAppSelector(state => state.user);
    const {
        bundles,
        updatedCart
    } = useAppSelector(state => state.cart);
    const dispatch = useAppDispatch();

    const activeLinkClassName = transparent
        ? 'navbar__link--active--transparent'
        : 'navbar__link--active';

    const numCartItems = bundles.length;

    if (!user) {
        return (
            <div className='navbar--signIn'></div>
        );
    }

    return (
        <div className={transparent ? 'navbar--transparent' : 'navbar'}>
            <div className='navbar__content'>
                {updatedCart &&
                    <div className='navbar__cartAdded'>
                        <div className='navbar__cartAddedHeader'>
                            <BiCartAlt className='navbar__cartAddedIcon' />
                            <p className='navbar__cartAddedTitle'>
                                Your cart - {numCartItems} {numCartItems > 1 ? 'items' : 'item'} added
                            </p>
                            <BiX
                                className='navbar__cartAddedClose'
                                onClick={() => dispatch(closeMessage())}
                            />
                        </div>
                        <ButtonLink
                            className='navbar__cartAddedButton'
                            to='/cart'
                            onClick={() => dispatch(closeMessage())}
                        >
                            VIEW CART
                        </ButtonLink>
                    </div>
                }
                {/* <Link to='/'>
                    <img 
                        src={TSCCLogo} 
                        alt='The SAT Crash Course'
                        className='navbar__logo'
                    />
                </Link> */}
                <Link to='/'>
                    <img 
                        src={PrepSharpLogo} 
                        alt='PrepSharp'
                        className='navbar__logo'
                    />
                </Link>
                <div className='navbar__links'> 
                    {/* <NavLink 
                        to='/courses'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        Courses
                    </NavLink> */}
                    {/* <NavLink
                        to='/tests'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        Tests
                    </NavLink> */}
                    <NavLink
                        to='/tests/digital-sat'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        HOME
                    </NavLink>
                    {/* <NavLink
                        to='/tests/digital-psat'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        PSAT
                    </NavLink> */}
                    <NavLink
                        to='/cart'
                        className={({ isActive }) => (
                            isActive ? 'navbar__link--active' : 'navbar__link'
                        )}
                    >
                        {bundles.length > 0 && 
                            <p className='navbar__cartBadge'>{numCartItems}</p>
                        }
                        <BiCartAlt className='navbar__icon' />
                    </NavLink>
                    <NavLink
                        to='/account'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        {user.profilePhoto
                            ? <img className='navbar__profile' src={user.profilePhoto} />
                            : <BiUserCircle className='navbar__icon' />
                        }
                        <p className='navbar__profileText'>
                            {user.firstName} {user.lastName}
                        </p>
                    </NavLink>
                </div>
                <Hamburger transparent={transparent} />
            </div>
        </div>
    );
}

export default Navbar;